async function importModules() {
	const [{
		Swiper,
		Autoplay,
		EffectFade,
		Pagination,
		Navigation
	}] = await Promise.all([
		import("swiper"),
		import("swiper/swiper-bundle.css")
	]);
	
	Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);
	
	return Swiper;
}

export default importModules;

const defaultSliderOptions = {
	effect: "slide",
	loop: true,
	autoplay: {
		delay: 6000,
		disableOnInteraction: false,
	},
	speed: 1000
};

export { defaultSliderOptions };
